<mat-card-subtitle>
  {{containerDesc}}
</mat-card-subtitle>

<form class="dynamic-form" [formGroup]="form" style="width: 100%">
  <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="8px grid">

    <mat-form-field fxFlex="20" width="100%">
      <mat-label>Voucher Code</mat-label>
      <input matInput style="text-align: left;" type="text" min="3" max="20" formControlName="wiCode" autocomplete="new-password">
    </mat-form-field>

    <mat-form-field fxFlex="35" width="100%">
      <mat-label>VSP</mat-label>
      <input matInput style="text-align: left;" type="text" formControlName="vspName" autocomplete="new-password">
    </mat-form-field>

    <mat-form-field fxFlex="15" width="100%">
      <mat-label>Value</mat-label>
      <input matInput style="text-align: right;" type="text" formControlName="couponValue" autocomplete="new-password">
    </mat-form-field>

    <div fxFlex="15" width="100%">
      <button [disabled]="form.controls['wiCode'].invalid || wiCodeDetails" mat-raised-button color="primary" (click)="validate()">Validate</button>
    </div>
    <div fxFlex="15" width="100%">
      <button [disabled]="!wiCodeDetails" mat-raised-button color="warn" (click)="resetValidation()">Reset</button>
    </div>

    <ng-container *ngIf="wiCodeDetails">
      <ng-container *ngIf="wiCodeDetails.isValidWiCode; else yoyoError">
        <mat-form-field fxFlex="30" width="100%">
          <mat-label>Amount Tendered</mat-label>
          <input matInput style="text-align: right;" type="number" formControlName="amountTendered" autocomplete="new-password"
            (keyup)="amountTenderedChanged()" (focusout)="amountTenderedFocusOut()">
        </mat-form-field>

        <mat-form-field fxFlex="40" width="100%">
          <mat-label>Minus Outstanding</mat-label>
          <input matInput style="text-align: right;" type="number" formControlName="amountOutstanding">
        </mat-form-field>

        <mat-form-field fxFlex="30" width="100%">
          <mat-label>Equals Unpaid</mat-label>
          <input matInput style="text-align: right;" type="number" formControlName="amountDifference">
        </mat-form-field>

        <p style="margin-top: -8px;"><b>Important:</b> Yoyo payments might use what is available, not necessarily what you entered. Double check the payment on the order to see the amount processed.</p>
      </ng-container>
    </ng-container>

    <ng-template #yoyoError>
      <div fxFlex="100">
        <p class="error-message" style="padding: 8px;border-radius: 5px;">{{wiCodeDetails.errorMessage}}</p>
      </div>
    </ng-template>
  </div>
</form>
